<template>
  <div>
    <div class="info_box mb20">
      <el-descriptions title="个人信息" size="large">
        <el-descriptions-item label="账号">{{ userInfo.userName }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">
          {{ userInfo.createTime }}
        </el-descriptions-item>
      </el-descriptions>
      <el-button type="primary" @click="passwordPopup = true">密码修改</el-button>
      <el-button type="primary" @click="changeBindPopup = true">手机号换绑</el-button>
    </div>
    <div class="info_box">
      <el-descriptions title="认证信息" size="large" v-if="authenticationInfo.userName">
        <el-descriptions-item label="名称">{{ authenticationInfo.userName }}</el-descriptions-item>
        <el-descriptions-item label="身份证号" v-if="authenticationInfo.userType == '01'">
          {{ authenticationInfo.userCode }}
        </el-descriptions-item>
        <el-descriptions-item label="认证状态">
          <el-tag type="info" v-if="authenticationInfo.status == 1">待审核</el-tag>
          <el-tag type="warning" v-if="authenticationInfo.status == 2">审核中</el-tag>
          <el-tag type="success" v-if="authenticationInfo.status == 3">审核通过</el-tag>
          <el-tag type="danger" v-if="authenticationInfo.status == 4">驳回</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="企业统一信用代码" v-if="authenticationInfo.userType == '02'">
          {{ authenticationInfo.companyCode }}</el-descriptions-item>
        <el-descriptions-item label="法人姓名" v-if="authenticationInfo.userType == '02'">
          {{ authenticationInfo.companyLegal }}
        </el-descriptions-item>
        <el-descriptions-item label="法人身份证" v-if="authenticationInfo.userType == '02'">
          {{ authenticationInfo.companyLegalCode }}
        </el-descriptions-item>
        <el-descriptions-item label="企业联系人" v-if="authenticationInfo.userType == '02'">
          {{ authenticationInfo.companyContact }}
        </el-descriptions-item>
        <el-descriptions-item label="企业联系方式" v-if="authenticationInfo.userType == '02'">
          {{ authenticationInfo.companyContactPhone }}
        </el-descriptions-item>
        <el-descriptions-item label="企业地址" v-if="authenticationInfo.userType == '02'">
          {{ authenticationInfo.companyAddress }}
        </el-descriptions-item>
        <el-descriptions-item label="银行账户名称">
          {{ authenticationInfo.bankAccountName }}
        </el-descriptions-item>
        <el-descriptions-item label="开户行名称">
          {{ authenticationInfo.bankName }}
        </el-descriptions-item>
        <el-descriptions-item label="银行账号">
          {{ authenticationInfo.bankNo }}
        </el-descriptions-item>
        <el-descriptions-item label="银行预留手机号">
          {{ authenticationInfo.bankPhone }}
        </el-descriptions-item>
      </el-descriptions>
      <el-button v-if="!authenticationInfo.userName" type="primary" @click="goRealName">实名认证</el-button>
      <el-button v-if="(authenticationInfo.status == 3 || authenticationInfo.status == 4) && authenticationInfo.userName" type="primary" @click="goRealName">重新提交实名认证</el-button>
    </div>

    <el-dialog title="密码修改" v-model="passwordPopup" width="40%">
      <el-form :model="formState" :rules="rules" ref="formState" label-width="110px" class="demo-formState"
        label-position="top">
        <el-form-item label="旧密码" prop="password">
          <el-input style="width: 300px;" v-model="formState.oldPassword" placeholder="请输入请输入密码" type="password"
            show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password1">
          <el-input style="width: 300px;" v-model="formState.newPassword" placeholder="请输入确认密码" type="password"
            show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="password2">
          <el-input style="width: 300px;" v-model="formState.newPassword2" placeholder="请输入确认密码" type="password"
            show-password></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="passwordPopup = false">取消</el-button>
          <el-button type="primary" @click="getChangePassword">
            确认修改
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="手机号换绑" v-model="changeBindPopup" width="40%">
      <el-form :model="formBindPhoneState" :rules="bindRules" ref="formBindState" label-width="110px"
        class="demo-formState" label-position="top">
        <el-form-item label="原手机号" prop="oldPhone" v-if="bindStep == 1">
          <el-input style="width: 300px;" v-model="formBindPhoneState.oldPhone" placeholder="请输入原手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="oldCode" v-if="bindStep == 1">
          <el-input style="width: 190px;" v-model="formBindPhoneState.oldCode" placeholder="请输入验证码" type="password"
            show-password></el-input>
          <el-button style="margin-left: 10px;" class="get-code" @click="handleCode">{{ countdownText }}</el-button>
        </el-form-item>

        <el-form-item label="新手机号" prop="newPhone" v-if="bindStep == 2">
          <el-input style="width: 300px;" v-model="formBindPhoneState.newPhone" placeholder="请输入新手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="newCode" v-if="bindStep == 2">
          <el-input style="width: 190px;" v-model="formBindPhoneState.newCode" placeholder="请输入验证码" type="password"
            show-password></el-input>
          <el-button style="margin-left: 10px;" class="get-code" @click="handleCodeNew">{{ countdownTextNew
            }}</el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="passwordPopup = false">取消</el-button>
          <el-button type="primary" @click="bindStep = 1" v-if="bindStep == 2">
            上一步
          </el-button>
          <el-button type="primary" @click="bindStep = 2" v-if="bindStep == 1">
            下一步
          </el-button>
          <el-button type="primary" @click="getUpdatePhone" v-if="bindStep == 2">
            确认修改
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>

</template>
<script>
import { userInfo, realNameInfo, updatePwd, sendMsg, updatePhone } from "@/utils/api";
export default {
  components: {

  },
  data() {
    return {
      authFlag: "",
      authenticationInfo: {},
      userInfo: {},
      passwordPopup: false,
      formState: {
        username: '',
        oldPassword: '',
        newPassword: '',
        newPassword2: '',
      },
      rules: {
        username: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        oldPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        newPassword2: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
      },

      formBindPhoneState: {
        oldPhone: '',
        oldCode: '',
        newPhone: '',
        newCode: '',
      },

      bindRules: {
        oldPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        oldCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        newPhone: [
          { required: true, message: "请输入新手机号", trigger: "blur" },
        ],
        newCode: [
          { required: true, message: "请输入新验证码", trigger: "blur" },
        ],
      },

      changeBindPopup: false,
      bindStep: 1,
      countdown: 60,
      countdownText: "获取验证码",
      isCountdown: false,

      countdownTextNew: "获取验证码",
      countdownNew: 60,
      isCountdownNew: false,
    };
  },
  mounted() {
    this.getUserInfo();
    this.getRealNameInfo();
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      userInfo().then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.userInfo = res.user;
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
          this.$router.push({
            path: "/",
          });
        }
      });
    },
    // 获取实名信息
    getRealNameInfo() {
      realNameInfo({ id: localStorage.userId }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          if (res.data) {
            this.authenticationInfo = res.data;
          }

        }
      });
    },
    // 实名认证
    goRealName() {
      this.$router.push({
        path: "/realNamePage",
      });
    },
    // 修改密码
    getChangePassword() {
      if (this.formState.newPassword != this.formState.newPassword2) {
        this.$message.error("两次密码不一致");
        return;
      }
      this.$refs.formState.validate((valid) => {
        if (valid) {
          // 通过new  FormData() 来创建一个对象
          let formData = new FormData();
          formData.append('oldPassword', this.formState.oldPassword);
          formData.append('newPassword', this.formState.newPassword);
          updatePwd(formData).then((res) => {
            if (res.code == 200) {
              this.$message.success("修改成功");
              localStorage.clear();
              this.$router.push("/loginPage");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });

    },

    handleCode() {
      if (this.formBindPhoneState.oldPhone == '' || this.formBindPhoneState.oldPhone == null) {
        this.$message.error('手机号不能为空');
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.formBindPhoneState.oldPhone)) {
        this.$message.error("手机号码有误，请重填");
        return;
      }
      if (this.isCountdown) {
        return;
      }
      sendMsg({ phone: this.formBindPhoneState.oldPhone }).then((res) => {
        if (res.code == 200) {
          this.isSend = true;
          this.countdown = 60;
          this.countdownText = "获取验证码";
          this.isCountdown = true;
          let timer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
              this.countdownText = this.countdown + "s";
            } else {
              this.isCountdown = false;
              this.countdownText = "获取验证码";
              clearInterval(timer);
            }
          }, 1000);
        }else {
          this.$message.error(res.msg);
        }
      })
    },

    handleCodeNew() {
      if (this.formBindPhoneState.newPhone == '' || this.formBindPhoneState.newPhone == null) {
        this.$message.error('手机号不能为空');
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.formBindPhoneState.newPhone)) {
        this.$message.error("手机号码有误，请重填");
        return;
      }
      if (this.isCountdownNew) {
        return;
      }
      sendMsg({ phone: this.formBindPhoneState.newPhone }).then((res) => {
        if (res.code == 200) {
          this.isSend = true;
          this.countdownNew = 60;
          this.countdownTextNew = "获取验证码";
          this.isCountdownNew = true;
          let timerNew = setInterval(() => {
            if (this.countdownNew > 0) {
              this.countdownNew--;
              this.countdownTextNew = this.countdownNew + "s";
            } else {
              this.isCountdownNew = false;
              this.countdownTextNew = "获取验证码";
              clearInterval(timerNew);
            }
          }, 1000);
        }else {
          this.$message.error(res.msg);
        }
      })
    },

    async getUpdatePhone() {
      let res = await updatePhone(this.formBindPhoneState);
      if (res.code == 200) {
        this.$message.success("修改成功");
        this.changeBindPopup = false;
        localStorage.clear();
        this.$router.push("/");
      }else {
        this.$message.error(res.msg);
      }
    }
  },

}
</script>
<style lang="scss" scoped></style>
